export default __webpack_public_path__ + "static/media/keyR.977624c3.svg";